import './App.css';

import Header from './Components/Header';
import PageRouter from './Components/PageRouter';

function App() {

  return (
    <div className="app">

      <Header />
      <PageRouter />
   </div>
  );
}

export default App;
